import { Box, Chip, Tooltip } from "@mui/material";

// Stability tags from the backend's TestStability (StabilityService): how a test's result in
// a run compares with its recent runs.
export const STABILITY_TAGS = {
	NEW_FAILURE: { label: "New failure", color: "error", variant: "filled", help: "Failed this time, passed the time before." },
	ALWAYS_FAILING: { label: "Always failing", color: "error", variant: "outlined", help: "Failed this time and in each of the 3 runs before." },
	FLAKY: { label: "Flaky", color: "warning", variant: "filled", help: "Its result changed 3 or more times over its last 10 runs." },
	FIXED: { label: "Fixed", color: "success", variant: "filled", help: "Passed this time, failed the time before." },
	SLOW: { label: "Slow", color: "info", variant: "outlined", help: "Passed, but took over 1.5× its usual time (and over 2 seconds longer)." },
};

export function StabilityChip({ tag, size = "small", sx }) {
	const info = STABILITY_TAGS[tag];
	if (!info) return null;
	return (
		<Tooltip title={info.help}>
			<Chip label={info.label} color={info.color} variant={info.variant} size={size} sx={{ height: 20, fontSize: "0.7rem", fontWeight: 600, ...sx }} />
		</Tooltip>
	);
}

/** Recent results, oldest → newest; the last one (this run) is ringed. */
export function HistoryDots({ history = [], sx }) {
	if (history.length < 2) return null;
	const passed = history.filter((s) => s === "SUCCESS").length;
	return (
		<Tooltip title={`Last ${history.length} runs, oldest first: ${passed} passed, ${history.length - passed} failed`}>
			<Box sx={{ display: "inline-flex", alignItems: "center", gap: "3px", ...sx }} aria-label={`Last ${history.length} runs: ${passed} passed`}>
				{history.map((s, i) => {
					const last = i === history.length - 1;
					return (
						<Box
							key={i}
							sx={{
								width: last ? 9 : 7,
								height: last ? 9 : 7,
								borderRadius: "50%",
								bgcolor: s === "SUCCESS" ? "success.main" : "error.main",
								outline: last ? "2px solid" : "none",
								outlineColor: "divider",
								outlineOffset: 1,
							}}
						/>
					);
				})}
			</Box>
		</Tooltip>
	);
}
